<template>
    <div v-if="isLoading" class="bg-[#02130E] fixed w-full h-full">
        <div class="w-10 h-10 rounded-full animate-spin border-solid border-4 border-[#CA3F79] border-t-transparent absolute top-[50%] left-[50%] ml-[-20px]"></div>
    </div>
    <div v-else class="bg-[#02130E] fixed h-full w-full">
        <div>
            <img src="../assets/login_bg.svg" class="absolute top-[-173px] w-full scale-[2] h-full">
        </div>
        <div class="flex justify-center absolute top-[20px] left-[50%] translate-x-[-50%]">
            <img src="@/mobileApp/assets/sportkit_logo.svg" alt="">
        </div>
        <div class="flex flex-col align-middle items-center justify-center w-full lg:w-[400px] absolute top-[50%] translate-y-[-50%] left-[50%] translate-x-[-50%]">
            <div class="flex justify-center">
                <img src="@/mobileApp/assets/logo.svg" class="logo w-[140px]" >
            </div>
            <div class="flex justify-center w-10/12 text-white text-[21px] mb-[18px] mt-[45px]">
                Hello champion!
            </div>
            <div class="bg-[#474849] bg-opacity-20 rounded-[9px] items-center px-[13px] border-[1px] border-[#D8E2DC] flex h-[44px] justify-center w-[90%] mb-[16px]">
                <div class="text-[#D8E2DC] text-[16px] font-semibold relative input-text">+380</div>
                <input v-model="studentLogin" type="text" @focus="removePlaceholderLogin" id="loginInput" class="input-text bg-transparent text-start placeholder:text-center rounded-[9px] outline-none text-[#D8E2DC] px-3 w-full placeholder-[#8C8C8C] placeholder:text-[13px] placeholder:relative pr-[50px]" placeholder="номер телефону">
            </div>
            <div class="bg-[#474849] bg-opacity-20 rounded-[9px] items-center px-[13px] border-[1px] border-[#D8E2DC] flex h-[44px] justify-center w-[90%] mb-[16px]">
                <input v-model="studentPassword" type="password" @focus="removePlaceholderPassword" id="passwordInput" class="input-text bg-transparent placeholder:text-center text-start rounded-[9px] outline-none text-[#D8E2DC] px-3 w-full placeholder-[#8C8C8C] placeholder:text-[13px]" placeholder="пароль">
            </div>
            <div class="flex justify-center w-[90%] mt-[10px] mb-[63px]">
                <button @click="sendAuthData" class="bg-[#D8E2DC] border-[1px] border-[#D8E2DC] rounded-[9px] items-center px-[13px] flex h-[44px] justify-center w-full mb-[16px]">
                    <div class="w-full text-[20px] text-black font-extrabold">Log in</div>

                </button>
            </div>
            <!-- <div>
                <img src="@/mobileApp/assets/banner.png" alt="">
            </div> -->
        </div>
        <div class="absolute bottom-[30px] left-[50%] translate-x-[-50%]">
            <!-- <div class="text-[#D8E2DC] text-[10px] text-center lg:mx-0 mb-[35px] mx-10">
                Привіт!<br>Це віртуальний кабінет для гравців ФК UCSA, якщо у тебе виникли проблеми з доступом, звернись до свого тренера
            </div> -->
            <div class="text-[#fff] text-[11px] text-center w-full">
                © 2023 ALL RIGHTS RESERVED
            </div>
        </div>
    </div>
</template>

<script>
    import { onMounted, ref } from 'vue'
    import { useRouter, useRoute } from 'vue-router'
    import { getTokens } from '../services/apiRequests'

    export default {
        name: 'Login',
        setup() {
            const router = useRouter()
            const route = useRoute()

            const studentLogin = ref('')
            const studentPassword = ref('')
            const isLoading = ref(false)

            const sendAuthData = async () => {
                isLoading.value = true
                const res = await getTokens('380' + studentLogin.value, studentPassword.value)
                if (res) {
                    router.go()
                } else {
                    isLoading.value = false
                    alert('Невірний логін або пароль')
                    studentLogin.value = ''
                    studentPassword.value = ''
                }
            }

            const removePlaceholderLogin = () => {
                var input = document.getElementById("loginInput");
                input.removeAttribute("placeholder");
            }

            const removePlaceholderPassword = () => {
                var input = document.getElementById("passwordInput");
                input.removeAttribute("placeholder");
            }

            onMounted(() => {
                console.log('there')
            })

            return {
                router,
                route,
                studentLogin,
                studentPassword,
                sendAuthData,
                removePlaceholderLogin,
                removePlaceholderPassword
            }
        }
    }
</script>

<style lang="scss" scoped>

    @font-face {
        font-family: 'FixelDisplay';
        src: url('../assets/FixelAll/FixelDisplay/FixelDisplay-SemiBold.ttf');
    }

    .input-text {
        font-family: 'FixelDisplay';
    }

</style>